<template>
  <app-layout title="Information">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        メール配信確認
      </h2>
    </template>
    <div class="px-4 py-4 flex flex-col items-center">
      <div class="mt-10 sm:mt-0 min-w-full">
        <div class="shadow overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-3">
                <label
                  class="block text-sm font-medium text-gray-700">
                  送信元
                </label>
                <label
                  class="block text-sm font-medium text-gray-700">
                  vt-info@qnote.co.jp
                </label>
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  class="block text-sm font-medium text-gray-700">
                  送信先
                </label>
                <select
                  v-model="form.dest_type"
                  :class="{ 'bg-red-100': !!form.errors.dest_type }"
                  class="pointer-events-none mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                  <option
                    v-for="(n, i) in destTypes"
                    :key="i"
                    :value="i">
                    {{ n }}
                  </option>
                </select>

                <div
                  v-if="
                    form.dest_type !== 0 &&
                      form.dest_type !== 3 &&
                      form.dest_type !== null">
                  <label
                    class="block text-sm font-medium text-gray-700">
                    対象の模試
                  </label>
                  <select
                    v-model="form.examinations"
                    :class="{ 'bg-red-100': !!form.errors.examinations }"
                    class="pointer-events-none mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                    <option
                      v-if="form.dest_type === 1"
                      value="0">
                      すべて
                    </option>
                    <option
                      v-for="(n, i) in examinations"
                      :key="i"
                      :value="i + 1">
                      {{ n.title }}
                    </option>
                  </select>
                </div>

                <div v-if="form.dest_type === 3">
                  <p
                    class="mt-4 block text-sm font-medium text-gray-700">
                    対象の送信先
                  </p>
                  <div
                    class="border w-full rounded border-gray-400 whitespace-pre-wrap py-2 px-3">
                    <p>{{ props.email }}</p>
                  </div>
                </div>

                <div v-if="form.dest_type !== 3">
                  <p
                    class="mt-4 block text-sm font-medium text-gray-700">
                    対象の送信先({{ props.totalCount }}件)
                  </p>
                  <div
                    class=" max-h-40 overflow-auto border-solid border-2 border-gray-400">
                    <p
                      v-for="(item, key) in destList"
                      :key="key">
                      {{ key }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-span-6">
                <label
                  for="contents"
                  class="block text-sm font-medium text-gray-700">
                  件名
                </label>
                <div
                  class="border w-full rounded border-gray-400 whitespace-pre-wrap py-2 px-3">
                  <p>{{ form.subject }}</p>
                </div>
              </div>

              <div class="col-span-6">
                <label
                  for="contents"
                  class="block text-sm font-medium text-gray-700">
                  本文
                </label>
                <div
                  class="border w-full rounded border-gray-400 whitespace-pre-wrap py-2 px-3">
                  <p v-html="aTagAddClass(form.contents)"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 bg-gray-50 flex justify-between sm:px-6">
            <div>
              <button
                class="py-2 px-4 mr-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-500 hover:bg-grey-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-grey-500"
                @click="onClickBackButton">
                戻る
              </button>
              <button
                v-if="!form.wasSuccessful"
                class="py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click.prevent="onSubmitted">
                送信する
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import { computed, reactive } from 'vue'
import AppLayout from '@/Layouts/AppLayout'

const props = defineProps({
  dest_type: {
    type: Number,
    default: 0,
  },
  examination: {
    type: Number,
    default: 1,
  },
  subject: {
    type: String,
    default: '',
  },
  contents: {
    type: String,
    default: '',
  },
  email: {
    type: String,
    default: '',
  },
  examinations: {
    type: Array,
    default: () => [],
  },
  destList: {
    type: Object,
    default: () => {},
  },
  totalCount: {
    type: Number,
    default: 0,
  },
})

const destTypes = computed(() => usePage().props.value.destTypes)

const formatCreatedAt = (information) => {
  const date = moment(information.created_at)
  const formatDate = date.format('yyyy/MM/DD kk:mm')
  return formatDate
}

const aTagAddClass = (content) => content.replace(/<a((?: .+?))?>(.*?)<\/a>/g, "<a $1 target='_blank' rel='opener referrer' class='mt-1 text-blue-700 border-b-[1px] border-blue-700 font-medium'>$2</a>")

const form = reactive(Inertia.form({
  id: null,
  _method: 'POST',
  dest_type: props.dest_type,
  examinations: props.examination,
  subject: props.subject,
  contents: props.contents,
  email: props.email,
}))

const onClickBackButton = () => {
  Inertia.post(route('mail.post'), {
    dest_type: props.dest_type,
    examinations: props.examination,
    subject: props.subject,
    contents: props.contents,
    email: props.email,
  })
}

const onSubmitted = async () => {
  await form.post(route('mail.send'), {
    dest_type: form.dest_type,
    examinations: form.examinations,
    subject: form.subject,
    contents: form.contents,
    email: form.email,
  })
}
</script>
